<div class="patient-personal-details-wrapper p-3">
  <!-- Personal Details Section -->
  <div class="mb-4">
    <div class="section-eyebrow mb-2">Patient Profile</div>
    <div class="detail-matrix">
      <div class="detail-chip">
        <span class="detail-chip__label">Full Name</span>
        <span class="detail-chip__value"
          >{{ patient?.title ? patient?.title + ' ' : '' }}{{ patient?.firstName || '—' }}
          {{ patient?.lastName || '' }}</span
        >
      </div>

      <div class="detail-chip">
        <span class="detail-chip__label">Gender</span>
        <span class="detail-chip__value">{{ patient?.gender || '—' }}</span>
      </div>

      <div class="detail-chip">
        <span class="detail-chip__label">Date of Birth / Age</span>
        <span class="detail-chip__value"
          >{{ patient?.dateOfBirth ?? '' | age }} yrs ({{
            patient?.dateOfBirth | date: 'dd MMM yyyy'
          }})</span
        >
      </div>

      <div class="detail-chip">
        <span class="detail-chip__label">ID Number</span>
        <span class="detail-chip__value">{{ patient?.idNumber || '—' }}</span>
      </div>

      <div class="detail-chip">
        <span class="detail-chip__label">Marital Status</span>
        <span class="detail-chip__value">{{ patient?.maritalStatus || '—' }}</span>
      </div>

      <div class="detail-chip">
        <span class="detail-chip__label">Email</span>
        <span class="detail-chip__value text-truncate">{{ patient?.email || '—' }}</span>
      </div>

      <div class="detail-chip">
        <span class="detail-chip__label">Phone Number</span>
        <span class="detail-chip__value">{{ patient?.phoneNumber || '—' }}</span>
      </div>

      @if (patient?.primaryDoctorName) {
        <div class="detail-chip">
          <span class="detail-chip__label">Primary Doctor</span>
          <span class="detail-chip__value text-primary"
            ><i class="bi bi-person-badge me-1"></i>{{ patient?.primaryDoctorName }}</span
          >
        </div>
      }
    </div>
  </div>

  <!-- Address Details Section -->
  <div class="mb-4">
    <div class="section-eyebrow mb-2">Physical Address</div>
    <div class="detail-chip w-100">
      <span class="detail-chip__label">Residential Location</span>
      <span class="detail-chip__value">
        <i class="bi bi-geo-alt-fill text-danger me-1"></i>
        {{ patient?.clinicPatient?.addressLine1 || 'No address line 1' }}
        @if (patient?.clinicPatient?.addressLine2) {
          , {{ patient?.clinicPatient?.addressLine2 }}
        }
        @if (patient?.clinicPatient?.addressLine3) {
          , {{ patient?.clinicPatient?.addressLine3 }}
        }
        @if (patient?.clinicPatient?.city) {
          , {{ patient?.clinicPatient?.city }}
        }
        @if (patient?.clinicPatient?.postalCode) {
          , {{ patient?.clinicPatient?.postalCode }}
        }
      </span>
    </div>
  </div>

  <!-- Payer Details Section -->
  @if (patient?.clinicPatient?.payer) {
    <div class="payer-card mt-3">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="section-eyebrow mb-0">Account Payer Details</div>
        <span class="badge bg-primary-subtle text-primary rounded-pill">Guarantor</span>
      </div>

      <div class="detail-matrix">
        <div class="detail-chip">
          <span class="detail-chip__label">Payer Name</span>
          <span class="detail-chip__value"
            >{{ patient?.clinicPatient?.payer?.firstName }}
            {{ patient?.clinicPatient?.payer?.lastName }}</span
          >
        </div>

        <div class="detail-chip">
          <span class="detail-chip__label">Payer Email</span>
          <span class="detail-chip__value text-truncate">{{
            patient?.clinicPatient?.payer?.email || '—'
          }}</span>
        </div>

        <div class="detail-chip">
          <span class="detail-chip__label">Payer Phone</span>
          <span class="detail-chip__value">{{
            patient?.clinicPatient?.payer?.phoneNumber || '—'
          }}</span>
        </div>

        @if (patient?.clinicPatient?.payer?.idNumber) {
          <div class="detail-chip">
            <span class="detail-chip__label">Payer ID Number</span>
            <span class="detail-chip__value">{{ patient?.clinicPatient?.payer?.idNumber }}</span>
          </div>
        }

        @if (patient?.clinicPatient?.payer?.employer) {
          <div class="detail-chip">
            <span class="detail-chip__label">Employer</span>
            <span class="detail-chip__value">{{ patient?.clinicPatient?.payer?.employer }}</span>
          </div>
        }

        @if (patient?.clinicPatient?.payer?.maritalStatus) {
          <div class="detail-chip">
            <span class="detail-chip__label">Marital Status</span>
            <span class="detail-chip__value">{{
              patient?.clinicPatient?.payer?.maritalStatus
            }}</span>
          </div>
        }
      </div>

      @if (patient?.clinicPatient?.payer?.addressLine1) {
        <div class="detail-chip w-100 mt-2">
          <span class="detail-chip__label">Billing Address</span>
          <span class="detail-chip__value">
            {{ patient?.clinicPatient?.payer?.addressLine1 }}
            @if (patient?.clinicPatient?.payer?.addressLine2) {
              , {{ patient?.clinicPatient?.payer?.addressLine2 }}
            }
            @if (patient?.clinicPatient?.payer?.addressLine3) {
              , {{ patient?.clinicPatient?.payer?.addressLine3 }}
            }
            @if (patient?.clinicPatient?.payer?.city) {
              , {{ patient?.clinicPatient?.payer?.city }}
            }
            @if (patient?.clinicPatient?.payer?.postalCode) {
              , {{ patient?.clinicPatient?.payer?.postalCode }}
            }
          </span>
        </div>
      }
    </div>
  }
</div>
